<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="sass">
@import '@/styles/default.sass'

#app
    font-family: $font-family
    overflow: hidden
    height: 100%
    color: $light-black

</style>
